/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_Mock_Col_CompanyInputs */

const en_cap_money_mock_col_company = /** @type {(inputs: Cap_Money_Mock_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const lv_cap_money_mock_col_company = /** @type {(inputs: Cap_Money_Mock_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzņēmums`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Cap_Money_Mock_Col_CompanyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_mock_col_company = /** @type {((inputs?: Cap_Money_Mock_Col_CompanyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_Mock_Col_CompanyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_mock_col_company(inputs)
	return en_cap_money_mock_col_company(inputs)
});